import { IconAI, Inline, Spread, Text } from 'braid-design-system';

import { CareerFeedBetaBadge } from './CareerFeedBetaBadge';

import * as styles from './CareerFeedAIHeading.css';

export const CareerFeedAIHeading = ({
  headingText,
}: {
  headingText: string;
  adjacent?: boolean;
}) => (
  <Inline space="xsmall" alignY="center">
    <Text size="large" weight="medium" icon={<IconAI tone="brandAccent" />}>
      <span className={styles.gradientText}>{headingText}</span>
    </Text>
  </Inline>
);

export const CareerFeedAIHeadingExperimental = ({
  headingText,
  adjacent = false,
}: {
  headingText: string;
  adjacent?: boolean;
}) =>
  adjacent ? (
    <Inline space="xsmall" alignY="center">
      <Text size="large" weight="medium" icon={<IconAI tone="brandAccent" />}>
        <span className={styles.gradientText}>{headingText}</span>
      </Text>
      <CareerFeedBetaBadge tone="neutral" />
    </Inline>
  ) : (
    <Spread space="small" alignY="center">
      <Text size="large" weight="medium" icon={<IconAI tone="brandAccent" />}>
        <span className={styles.gradientText}>{headingText}</span>
      </Text>
      <CareerFeedBetaBadge tone="neutral" />
    </Spread>
  );
